// extracted by mini-css-extract-plugin
export var button = "_dx-4";
export var hasDarkBackground = "_dx-7";
export var hasLightBackground = "_dx-6";
export var iconWrapper = "_dx-0";
export var large = "_dx-2";
export var medium = "_dx-1";
export var small = "_dx-5";
export var xsmall = "_dx-3";